<template >
    <div>
        <section class="container-widget" v-for="(widget, widgetIndex) in sectionData.widgets" :key="widgetIndex">
            <WidgetsModulesOther :widget="widget" />
        </section>
    </div>
</template>
<script>

import WidgetsModulesOther from "@/components/widgets/WidgetsModulesOther.vue";
export default {
    components: {
        WidgetsModulesOther,
    },
    props: ["sectionData"],
};
</script>
<style lang="scss" scoped>

</style>
